<template>
  <div class="content">
    <div class="page">
      <h2>人行管理</h2>
      <div class="message">
        通过物联设备，对出入口人员通道控制系统进行管理，使业主、租户刷脸进出小区。
      </div>
      <img
        src="../../../../assets/image/residentialQuartersImg/蒙版组 150.png"
        alt=""
      />
      <h2>车行管理</h2>
      <div class="message">
        通过车牌识别摄像头一体机对进出车辆进行控制，分析进入车辆身份。结合地磁感应有效管理车位信息。
      </div>
      <img
        src="../../../../assets/image/residentialQuartersImg/蒙版组 149.png"
        alt=""
      />
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  name: "",
  data() {
    return {};
  },

  methods: {},
};
</script>
 
<style scoped lang="scss">
.content {
  padding: 0 16%;
  box-sizing: border-box;
  min-height: calc(100vh - 387px);
  width: 100%;
  margin-bottom: 50px;
  .page {
    margin-top: 50px;
    width: 100%;
    // height: 720px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px;
    padding-bottom: 50px;
    // position: relative;
    text-align: center;
    > h2 {
      text-align-last: left;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin: 10px 0 30px 0;
    }
    .message {
      text-align-last: left;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6b6b6b;
      margin-bottom: 50px;
    }
  }
}
</style>